import React, { useState } from 'react';
import styled from 'styled-components';
import SharedPageLayout from './SharedPageLayout';
import PeuplesMap from './PeuplesMap';
import CulturalRegionsMap from './CulturalRegionsMap';
import { theme } from '../theme';

const CommunauteMainSection = styled.section`
  width: 100%;
  padding: 20px 5% 80px 5%;

  @media (max-width: 768px) {
    padding: 15px 4% 60px 4%;
  }

  @media (max-width: 480px) {
    padding: 10px 3% 40px 3%;
  }
`;

const CommunauteMainContent = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 60px;

  @media (max-width: 768px) {
    gap: 40px;
  }

  @media (max-width: 480px) {
    gap: 32px;
  }
`;

const SectionTitle = styled.h2`
  font-family: ${theme.fonts.title};
  font-weight: 600;
  font-size: 32px;
  line-height: 40px;
  color: ${theme.colors.outchou_blue};
  text-align: center;
  margin: 0 0 20px 0;

  @media (max-width: 768px) {
    font-size: 28px;
    line-height: 36px;
  }

  @media (max-width: 480px) {
    font-size: 24px;
    line-height: 32px;
  }
`;

const SectionDescription = styled.p`
  font-family: ${theme.fonts.body};
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: ${theme.colors.gray};
  text-align: justify;
  margin: 0 0 40px 0;
  max-width: 800px;
  margin-left: auto;
  margin-right: auto;

  @media (max-width: 480px) {
    font-size: 14px;
    line-height: 21px;
  }
`;

const MapSection = styled.div`
  margin-top: 0;
`;

const SwitchContainer = styled.div`
  display: flex;
  justify-content: center;
  gap: 12px;
  margin-bottom: 24px;
`;

const SwitchButton = styled.button<{ $active: boolean }>`
  padding: 12px 24px;
  border: 2px solid ${props => props.$active ? theme.colors.outchou_green : theme.colors.gray};
  border-radius: 8px;
  background-color: ${props => props.$active ? theme.colors.outchou_green : 'white'};
  color: ${props => props.$active ? 'white' : theme.colors.gray};
  font-family: ${theme.fonts.body};
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  
  &:hover {
    background-color: ${props => props.$active ? theme.colors.outchou_green : '#f5f5f5'};
    border-color: ${props => props.$active ? theme.colors.outchou_green : theme.colors.outchou_green};
    color: ${props => props.$active ? 'white' : theme.colors.outchou_green};
  }
  
  @media (max-width: 480px) {
    padding: 10px 20px;
    font-size: 14px;
  }
`;

const CommunautePage: React.FC = () => {
  const [mapType, setMapType] = useState<'peuples' | 'cultural'>('peuples');
  
  return (
    <SharedPageLayout 
      heroType="search"
      backgroundImage="/shared_assets/images/navigation/communaute.jpeg"
      heroTitle="Peuples"
      heroSubtitle="Façonnée par une mosaïque de peuples et de langues, l’Algérie est plurielle. De la Kabylie au Sahara, chaque région porte une identité issue d’une histoire millénaire."    >
      <CommunauteMainSection>
          <MapSection>
          <SectionTitle>Cliquez sur un point coloré pour en savoir plus.</SectionTitle>
          <SwitchContainer>
            <SwitchButton 
              $active={mapType === 'peuples'} 
              onClick={() => setMapType('peuples')}
            >
              Peuples
            </SwitchButton>
            <SwitchButton 
              $active={mapType === 'cultural'} 
              onClick={() => setMapType('cultural')}
            >
              Régions Culturelles
            </SwitchButton>
          </SwitchContainer>
          {mapType === 'peuples' ? <PeuplesMap /> : <CulturalRegionsMap />}
          </MapSection>
      </CommunauteMainSection>
    </SharedPageLayout>
  );
};

export default CommunautePage;